import { render, staticRenderFns } from "./vSelectFx.vue?vue&type=template&id=cd3c9dce"
import script from "./vSelectFx.vue?vue&type=script&lang=ts"
export * from "./vSelectFx.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports